import { Guid } from "@/types"

export interface IGetProfitCenterPermissionsItemDto {
    userId: Guid
    profitCenterIds: Guid[]
}

export type GetProfitCenterPermissions = IGetProfitCenterPermissionsItemDto[]

export default class ProfitCenterPermissions {
    items: Record<Guid, Guid[]> // <userId, profitCenterIds[]>

    constructor(dto: GetProfitCenterPermissions) {
        this.items = dto.reduce((acc, entity) => {
            acc[entity.userId] = entity.profitCenterIds
            return acc
        }, {})
    }
}

